import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/global.css";
import "./styles/variables.css";
import { setupAxiosInterceptors } from "./services/servicesHelper.ts";

setupAxiosInterceptors();

window.addEventListener('unhandledrejection', function(event) {
  console.error('nc --Unhandled Promise Rejection:', event.reason);
});
window.onerror = function(message, source, lineno, colno, error) {
  console.error('nc -- Unhandled Error:', {
    message,
    source,
    lineno,
    colno,
    error,
  });
};

createRoot(document.getElementById("root")!).render(<App />);
